var timelineContent = document.getElementById('m-timeline__content');
if (timelineContent) {
	var timelineLeft = document.getElementById('m-timeline__scroll-left');
	var timelineRight = document.getElementById('m-timeline__scroll-right');

	var timelineElemens = document.getElementsByClassName('a-timeline-event');
	var timelineElementWidth = timelineElemens[0].offsetWidth;

	function timelineDisable() {
		var maxScrollLeft = timelineContent.scrollWidth - timelineContent.clientWidth;
		
		if(timelineContent.scrollLeft == 0 ) {
			timelineLeft.classList.add('m-timeline__scroll--disabled');
		} else {
			timelineLeft.classList.remove('m-timeline__scroll--disabled');
		}

		if(timelineContent.scrollLeft == maxScrollLeft ) {
			timelineRight.classList.add('m-timeline__scroll--disabled');
		} else {
			timelineRight.classList.remove('m-timeline__scroll--disabled');
		}
	}

	timelineDisable();

	timelineLeft.addEventListener('click', function() {
		timelineContent.scrollLeft -= timelineElementWidth ;

		setTimeout(function(){
			timelineDisable();
		}, 500);
	});

	timelineRight.addEventListener('click', function() {
		timelineContent.scrollLeft += timelineElementWidth ;
		
		setTimeout(function(){
			timelineDisable();
		}, 500);
	});

}